<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <KTPortlet v-bind:title="$t('MENU.DOMAINS')">
          <template v-slot:toolbar>
            <b-button
              variant="primary"
              class="mr-4"
              v-b-modal.addDomain
              v-if="canAdd"
            >
              {{ $t("COMMON.NEW") }}
            </b-button>
            <b-button
              variant="danger"
              v-b-modal.confirm-1
              :disabled="selected.length == 0"
              v-if="canRemove"
            >
              {{ $t("COMMON.DELETE") }}
            </b-button>
            <!-- Add modal -->
            <b-modal
              id="addDomain"
              ref="addDomain"
              class="chPass-modal"
	      :title="$t('DOMAINS.ADD_DOMAIN')"
            >
              <b-container fluid>
                <b-row class="my-4">
                  <b-col sm="5">
                    <label for="newDomain">{{
                      $t("DOMAINS.NEW_DOMAIN")
                    }}</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-input
                      id="newDomain"
                      v-model="$v.form.newDomain.$model"
                      :state="validateState('newDomain')"
                      :placeholder="$t('DOMAINS.NEW_DOMAIN')"
                      aria-describedby="input-new-domain-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-new-domain-feedback">{{
                      $t("VALIDATION.DOMAIN_FIELD")
                    }}</b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <!---<b-row class="my-4">
                  <b-col sm="5">
                    <label for="newDomain">{{
                      $t("DOMAINS.DOMAIN_TYPE")
                    }}</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-select
                      v-model="domainType"
                      value-field="value"
                      text-field="name"
                      :options="domainTypesOptions"
                    ></b-form-select>
                  </b-col>
                </b-row>-->
              </b-container>
              <template v-slot:modal-footer>
                <b-button variant="outline-secondary" v-on:click="modalClose()">
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="primary" v-on:click="createItem()">
                  {{ $t("DOMAINS.ADD_DOMAIN") }}
                </b-button>
              </template>
            </b-modal>
          </template>
          <template v-slot:body>
            <div class="row table-filter">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('COMMON.SEARCH')"
                  class="cus-searchBox"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="allDomains"
              :single-select="singleSelect"
              :search="search"
              show-select
              item-key="domain"
              class="elevation-1"
              ref="domainTable"
              :footer-props="{
                showFirstLastPage: true,
              }"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <template v-if="!isMobile">
                    <tr
                      v-for="item in items"
                      :key="item.domain"
                      :class="{ unactiveRow: item.active == 0 }"
                    >
                      <td>
                        <v-checkbox
                          v-model="selected"
                          :value="item"
                          style="margin: 0px; padding: 0px"
                          class="cusTable-checkbox"
                          color="rgba(0,0,0,.54)"
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-start">
                        {{ item.domain }}
                      </td>
                      <td class="text-start">
                          <b-button
                            pill
                            size="sm"
                            style="width: 100px;"
                            :variant="item.health<3 ? 'danger':item.health<5 ? 'warning':'success'" 
                            @click="showDomainHealth(item)" 
                            v-b-tooltip.hover
                            :title="$t('COMMON.MORE_DETAILS')"
                          >
                            {{ item.healthStatus }}
                          </b-button>
                      </td>
                      <td class="text-start">
			                  <span v-if="item.domaintype != 9">
                          <v-icon
                            medium
                            color="dark"
                            class="mr-4"
                            @click="showItemInfor(item)"
                            v-b-tooltip.hover
                            v-if="canAdd"
                            :title="$t('COMMON.EDIT')"
                          >
                            edit
                          </v-icon>
			  <v-icon
  				medium
  				color="dark"
  				class="mr-4"
  				@click="showAiSettings(item)"
  				v-b-tooltip.hover
  				v-if="canAdd"
  				:title="$t('DOMAINS.AI_SETTINGS')"
			  >
  				auto_awesome	
			  </v-icon>
                          <v-icon
                            medium
                            color="dark"
                            class="mr-4"
                            @click="showItemFooter(item)"
                            v-b-modal.item-footer
                            v-b-tooltip.hover
                            v-if="canAdd"
                            :title="$t('COMMON.FOOTER')"
                          >
                            computer
                          </v-icon>
                          <v-icon
                            medium
                            color="dark"
                            class="mr-4"
                            @click="showDkimSetting(item)"
                            v-b-tooltip.hover
                            v-if="canAdd"
                            :title="$t('DOMAINS.DKIM_SETTINGS')"
                          >
                            settings
                          </v-icon>
			                  </span>
			                  <span v-if="item.domaintype == 9">
                          <v-icon
                            medium
                            color="red"
                            class="mr-4"
                            @click="showDomainVerification(item)"
                            v-b-tooltip.hover
                            :title="$t('DOMAINS.VERIFY')"
                          >
                            domain_verification
                          </v-icon>
                        </span>
                        <v-icon
                          medium
                          color="dark"
                          @click="saveDeltem(item)"
                          v-b-modal.confirm-2
                          v-b-tooltip.hover
                          v-if="canRemove"
                          :title="$t('COMMON.DELETE')"
                        >
                          delete
                        </v-icon>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr
                      v-for="item in items"
                      :key="item.domain"
                      :class="{
                        unactiveRow: item.active == 0,
                      }"
                    >
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header"></div>
                        <v-checkbox
                          v-model="selected"
                          :value="item"
                          style="margin: 0px; padding: 0px"
                          class="cusTable-checkbox"
                          color="rgba(0,0,0,.54)"
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header">
                          {{ $t("COMMON.DOMAIN") }}
                        </div>
                        <div class="v-data-table__mobile-row__cell">
                          {{ item.domain }}
                        </div>
                      </td>
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header">
                          {{ $t("DOMAINS.HEALTH") }}
                        </div>
                        <div class="v-data-table__mobile-row__cell">
                          <b-button 
                            pill
                            size="sm"
                            style="width: 80px;"
                            :variant="item.health<3 ? 'danger':item.health<5 ? 'warning':'success'" 
                            @click="showDomainHealth(item)" 
                            v-b-tooltip.hover
                            :title="$t('COMMON.MORE_DETAILS')"
                          >
                            {{ item.healthStatus }}
                          </b-button>
                        </div>
                      </td>
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header">
                          {{ $t("COMMON.ACTION") }}
                        </div>
                        <div class="v-data-table__mobile-row__cell">
			                    <span v-if="item.domaintype != 9">
                            <v-icon
                              medium
                              color="dark"
                              class="mr-4"
                              @click="showItemInfor(item)"
                              v-b-tooltip.hover
                              v-if="canAdd"
                              :title="$t('COMMON.EDIT')"
                            >
                              edit
                            </v-icon>
			    <v-icon
  				medium
  				color="dark"
  				class="mr-4"
  				@click="showAiSettings(item)"
  				v-b-tooltip.hover
  				v-if="canAdd"
  				:title="$t('DOMAINS.AI_SETTINGS')"
		            >
  				auto_awesome	
			    </v-icon>
                            <v-icon
                              medium
                              color="dark"
                              class="mr-4"
                              @click="showItemFooter(item)"
                              v-b-modal.item-footer
                              v-b-tooltip.hover
                              v-if="canAdd"
                              :title="$t('COMMON.FOOTER')"
                            >
                              computer
                            </v-icon>
			                    </span>
			                    <span v-if="item.domaintype == 9">
                            <v-icon
                              medium
                              color="red"
                              class="mr-4"
                              @click="showDomainVerification(item)"
                              v-b-tooltip.hover
                              :title="$t('DOMAINS.VERIFY')"
                            >
                              domain_verification 
                            </v-icon>
			                    </span>
                          <v-icon
                            medium
                            color="dark"
                            @click="saveDeltem(item)"
                            v-b-modal.confirm-2
                            v-b-tooltip.hover
                            v-if="canRemove"
                            :title="$t('COMMON.DELETE')"
                          >
                            delete
                          </v-icon>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-data-table>

            <!-- Delete confirm modals -->
            <b-modal
              id="confirm-1"
              :title="$t('COMMON.DEL_CONFIRM')"
              ref="delConfirm-modal"
            >
              <p class="my-1">
                {{ $t("COMMON.DEL_WARNING") }}
              </p>
              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('delConfirm-modal')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="danger" v-on:click="deleteItems">
                  {{ $t("COMMON.DELETE") }}
                </b-button>
              </template>
            </b-modal>
            <b-modal
              id="confirm-2"
              :title="$t('COMMON.DEL_CONFIRM')"
              ref="delConfirm-modal"
            >
              <p class="my-1">
                {{ $t("COMMON.DEL_ITEM_WARNING", { item: delItem.domain }) }}
              </p>
              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('delConfirm-modal')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="danger" v-on:click="deleteOneItem">
                  {{ $t("COMMON.DELETE") }}
                </b-button>
              </template>
            </b-modal>
            <!-- Domain health modal -->
            <b-modal
              id="modal-health"
              :title="$t('DOMAINS.DOMAIN_HEALTH') + showItem.domain"
              ref="modal-health"
            >
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("COMMON.STATUS") }}: </b>
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.health <= 1 ? 'danger' : 'success'"
                    href="#"
                  >
                    {{ showItem.verification == 1 ? $t("DOMAINS.VERIFYING") : showItem.active == 1 ? $t("COMMON.ENABLED") : $t("COMMON.DISABLED") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.MX_RECORDS") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.mx_health == 1 ? 'success' : 'danger'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_MX')"
                  >
                    {{ showItem.mx_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4" v-if="showItem.caa_block==1">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.CAA_RECORD") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    variant="warning"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_CAA')"
                  >
                    {{ showItem.caa_block == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.WEBMAIL_RECORD") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.webmail_health == 1 ? 'success' : 'warning'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_WEBMAIL')"
                  >
                    {{ showItem.webmail_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.WEBMAIL_SSL") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.webmail_ssl == 1 ? 'success' : 'warning'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_WEBMAIL_SSL')"
                  >
                    {{ showItem.webmail_ssl == 1 ? $t("DOMAINS.INSTALLED") : $t("DOMAINS.NOT_INSTALLED") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.AUTODISCOVER_RECORD") }}: </b>
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.autodiscover_health == 1 ? 'success' : 'warning'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_AUTODISCOVER')"
                  >
                    {{ showItem.autodiscover_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
                  </b-badge>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.AUTODISCOVER_SSL") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.autodiscover_ssl == 1 ? 'success' : 'warning'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_AUTODISCOVER_SSL')"
                  >
                    {{ showItem.autodiscover_ssl == 1 ? $t("DOMAINS.INSTALLED") : $t("DOMAINS.NOT_INSTALLED") }}
                  </b-badge>
                </b-col>
              </b-row>
<b-row class="my-4">
  <b-col sm="5">
    <b>{{ $t("DOMAINS.AUTOCONFIG_RECORD") }}: </b>
  </b-col>
  <b-col sm="7">
    <b-badge pill
      :variant="showItem.autoconfig_health == 1 ? 'success' : 'warning'"
      href="#"
      v-b-tooltip.hover
      :title="$t('DOMAINS.EXPL_AUTOCONFIG')"

    >
      {{ showItem.autoconfig_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
    </b-badge>
  </b-col>
</b-row>

<!-- NEW: AUTOCONFIG_SSL -->
<b-row class="my-4">
  <b-col sm="5">
    <b>{{ $t("DOMAINS.AUTOCONFIG_SSL") }}: </b>
  </b-col>
  <b-col sm="7">
    <b-badge pill
      :variant="showItem.autoconfig_ssl == 1 ? 'success' : 'warning'"
      href="#"
     v-b-tooltip.hover
     :title="$t('DOMAINS.EXPL_AUTOCONFIG_SSL')"

    >
      {{ showItem.autoconfig_ssl == 1 ? $t("DOMAINS.INSTALLED") : $t("DOMAINS.NOT_INSTALLED") }}
    </b-badge>
  </b-col>
</b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <b>{{ $t("DOMAINS.SPF_RECORD") }}: </b> 
                </b-col>
                <b-col sm="7">
                  <b-badge pill 
                    :variant="showItem.spf_health == 1 ? 'success' : 'warning'"
                    href="#"
                    v-b-tooltip.hover
                    :title="$t('DOMAINS.EXPL_SPF')"
                  >
                    {{ showItem.spf_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
                  </b-badge>
                </b-col>
              </b-row>
<b-row class="my-4">
  <b-col sm="5">
    <b>{{ $t("DOMAINS.DKIM_RECORD") }}: </b>
  </b-col>
  <b-col sm="7">
    <b-badge pill
      :variant="showItem.dkim_health == 1 ? 'success' : 'warning'"
      href="#"
      v-b-tooltip.hover
      :title="$t('DOMAINS.EXPL_DKIM')"

    >
      {{ showItem.dkim_health == 1 ? $t("DOMAINS.FOUND") : $t("DOMAINS.NOT_FOUND") }}
    </b-badge>
  </b-col>
</b-row>
              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('modal-health')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button
                  variant="outline-secondary"
                  v-on:click="getDomainHealth()"
                >
                  {{ $t("COMMON.REFRESH") }}
                </b-button>
                <b-button variant="primary" v-on:click="checkDomainHealthNext">
                  {{ $t("DOMAINS.VERIFY_AGAIN") }}
                </b-button>
              </template>
            </b-modal>
            <!-- Update modal -->
            <b-modal
              :title="$t('COMMON.UPDATE') + updateItem"
              ref="editDomain-modal"
            >
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">{{
                    $t("DOMAINS.DOMAIN_TIMEZONE")
                  }}</label>
                </b-col>
                <b-col sm="7">
                  <b-form-select
                    v-model="updateform.timeZone.selected"
                    value-field="timezone"
                    text-field="timezone"
                    :options="updateform.timeZone.data"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">{{
                    $t("COMMON.HOME_COUNTRY")
                  }}</label>
                </b-col>
                <b-col sm="7">
                  <model-list-select :list="updateform.homeCountry.data"
                    v-model="updateform.homeCountry.selected"
                    option-value="value"
                    option-text="text">
                  </model-list-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">
                    {{ $t("DOMAINS.CATCHALL") }}
                  </label>
                </b-col>
                <b-col sm="7">
                  <b-form-select
                    v-model="updateform.catmail.selected"
                    value-field="value"
                    text-field="name"
                    :options="catmailData"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">
                    {{ $t("COMMON.ACTIVE") }}
                  </label>
                </b-col>
                <b-col sm="7">
                  <b-form-select
                    v-model="updateform.active.selected"
                    value-field="value"
                    text-field="name"
                    :options="activeData"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">
                    {{ $t("DOMAINS.LOCAL_DELIVERY") }}
                  </label>
                </b-col>
                <b-col sm="7">
                  <b-form-select
                    v-model="updateform.localDelivery.selected"
                    value-field="value"
                    text-field="name"
                    :options="localDeliveryData"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="5">
                  <label class="mb-0">
                    {{ $t("DOMAINS.AUDIT_ENABLED") }}
                  </label>
                </b-col>
                <b-col sm="7">
                  <b-form-select
                    v-model="updateform.audit.selected"
                    value-field="value"
                    text-field="name"
                    :options="auditData"
                  ></b-form-select>
                </b-col>
              </b-row>
              <template v-slot:modal-footer>
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('editDomain-modal')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="danger" @click="updateItemInfor()">
                  {{ $t("COMMON.UPDATE") }}
                </b-button>
              </template>
            </b-modal>
<!-- NEW: AI Settings modal -->
            <b-modal
              :title="$t('DOMAINS.AI_SETTINGS') + ' (' + aiItem + ')'"
              ref="AI-modal"
              size="lg"
              hide-footer
            >
              <!-- Loading State -->
              <div v-if="aiLoading" class="text-center my-4">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
              </div>

              <!-- Main Content -->
              <div v-else>
                <!-- Error Alert -->
                <b-alert show variant="danger" v-if="aiStatusError" dismissible @dismissed="aiStatusError=''">
                  {{ aiStatusError }}
                </b-alert>

                <!-- VIEW 1: LIST CONFIGURED PROVIDERS -->
                <div v-if="!aiWizardMode">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0">{{ $t('DOMAINS.AI_CONFIGURED_PROVIDERS') }}</h5>
                    <b-button 
                      variant="primary" 
                      size="sm" 
                      @click="aiStartWizard()" 
                      :disabled="availableProvidersToAdd.length === 0"
                    >
                      <v-icon small color="white" class="mr-1">add</v-icon>
                      {{ $t('DOMAINS.AI_ADD_PROVIDER') }}
                    </b-button>
                  </div>

                  <b-list-group v-if="activeProvidersList.length > 0" class="mb-4">
                    <b-list-group-item 
                      v-for="p in activeProvidersList" 
                      :key="p.key"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <div class="d-flex align-items-center">
                          <h6 class="mb-0 mr-2">{{ p.label }}</h6>
                          <b-badge v-if="aiDefaultProvider === p.key" variant="primary">{{ $t('COMMON.DEFAULT') }}</b-badge>
                        </div>
                        <small class="text-muted" v-if="p.model">Model: {{ p.model }}</small>
                        <small class="text-muted" v-else>{{ $t('DOMAINS.AI_MODEL_NOT_SELECTED') }}</small>
                      </div>
                      <div>
                        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="aiEditProvider(p.key)">
                          {{ $t('COMMON.EDIT') }}
                        </b-button>
                         <!-- Set Default Button -->
                        <b-button 
                          v-if="aiDefaultProvider !== p.key"
                          variant="outline-primary" 
                          size="sm" 
                          class="mr-2" 
                          @click="aiSetDefault(p.key)"
                        >
                          {{ $t('DOMAINS.AI_MAKE_DEFAULT') }}
                        </b-button>
                        <b-button variant="outline-danger" size="sm" @click="aiConfirmDelete(p.key)">
                          {{ $t('COMMON.DELETE') }}
                        </b-button>
                      </div>
                    </b-list-group-item>
                  </b-list-group>

                  <div v-else class="text-center py-4 text-muted bg-light rounded mb-4">
                    {{ $t('DOMAINS.AI_NO_PROVIDERS') }}
                  </div>
                  
                  <div v-if="activeProvidersList.length === 0 && availableProvidersToAdd.length > 0" class="text-center">
                     <small>{{ $t('DOMAINS.AI_ADD_FIRST_PROVIDER_HINT') }}</small>
                  </div>
                </div>

                <!-- VIEW 2: ADD/EDIT WIZARD -->
                <div v-else class="bg-light p-4 rounded border">
                  <div class="d-flex justify-content-between mb-3">
                    <h5>{{ aiEditMode ? $t('DOMAINS.AI_EDIT_PROVIDER') : $t('DOMAINS.AI_ADD_PROVIDER') }}</h5>
                    <b-button variant="link" class="text-muted p-0" @click="aiCancelWizard">
                      <v-icon>close</v-icon>
                    </b-button>
                  </div>

                  <!-- Step 1: Select Provider (Only in Add mode) -->
                  <b-form-group :label="$t('DOMAINS.AI_PROVIDER')" v-if="!aiEditMode">
                    <b-form-select
                      v-model="aiWizard.provider"
                      :options="availableProvidersToAdd"
                      :disabled="aiWizard.testing"
                    ></b-form-select>
                  </b-form-group>
                  <div v-else class="mb-3">
                    <strong>{{ $t('DOMAINS.AI_PROVIDER') }}:</strong> {{ aiProviderLabel(aiWizard.provider) }}
                  </div>

                  <!-- Step 2: API Key -->
                  <b-form-group 
                    :label="$t('DOMAINS.AI_API_KEY')" 
                    :description="$t('DOMAINS.AI_API_KEY_DESC')"
                  >
                    <b-form-input
                      type="password"
                      v-model="aiWizard.apiKey"
                      :placeholder="aiEditMode ? $t('DOMAINS.AI_LEAVE_BLANK_TO_KEEP') : 'sk-...'"
                      :disabled="aiWizard.testing"
                    ></b-form-input>
                  </b-form-group>

                  <!-- Verify Button (Shows before model select) -->
                  <div class="mb-3" v-if="!aiWizard.modelsLoaded">
                    <b-button 
                      variant="info" 
                      @click="aiVerifyAndFetchModels"
                      :disabled="!aiCanVerify || aiWizard.testing"
                      class="d-flex align-items-center"
                    >
                      <b-spinner small v-if="aiWizard.testing" class="mr-2"></b-spinner>
                      <span>{{ $t('DOMAINS.AI_VERIFY_FETCH_MODELS') }}</span>
                    </b-button>
                    <small class="text-muted d-block mt-1" v-if="aiWizard.testing">{{ $t('DOMAINS.AI_TESTING_CONNECTION') }}</small>
                  </div>

                  <!-- Step 3: Select Model (Shown after verification) -->
                  <div v-if="aiWizard.modelsLoaded">
                    <b-alert show variant="success" class="p-2 mb-3">
                      <v-icon small color="success" class="mr-1">check_circle</v-icon> {{ $t('DOMAINS.AI_KEY_VALID') }}
                    </b-alert>
                  
                    <b-form-group :label="$t('DOMAINS.AI_SELECT_MODEL')">
                      <b-form-select
                        v-model="aiWizard.selectedModel"
                        :options="aiWizard.modelOptions"
                        value-field="id"
                        text-field="name"
                        :disabled="aiWizard.saving"
                      ></b-form-select>
                    </b-form-group>

                    <div class="d-flex justify-content-end mt-4">
                      <b-button variant="secondary" class="mr-2" @click="aiCancelWizard" :disabled="aiWizard.saving">
                        {{ $t('COMMON.CANCEL') }}
                      </b-button>
                      <b-button 
                        variant="success" 
                        @click="aiSaveProvider"
                        :disabled="!aiWizard.selectedModel || aiWizard.saving"
                      >
                        <b-spinner small v-if="aiWizard.saving" class="mr-1"></b-spinner>
                        <span>{{ $t('COMMON.SAVE') }}</span>
                      </b-button>
                    </div>
                  </div>

                </div>
              </div>
            </b-modal>

            <!-- NEW: AI delete key confirm modal -->
            <b-modal
              id="ai-delete-key"
              :title="$t('COMMON.DEL_CONFIRM')"
              ref="AI-delete-modal"
            >
              <p class="my-1">
                {{
                  $t('DOMAINS.AI_DELETE_CONFIRM', {
                    provider: aiProviderLabel(aiDeleteProvider),
                    domain: aiItem
                  })
                }}
              </p>
              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('AI-delete-modal')"
                >
                  {{ $t('COMMON.CANCEL') }}
                </b-button>
                <b-button variant="danger" @click="aiDeleteProviderKey">
                  {{ $t('COMMON.DELETE') }}
                </b-button>
              </template>
            </b-modal>
            <!-- DKIM Settings modal -->
            <b-modal
              :title="$t('DOMAINS.DKIM_SETTINGS') + '(' + dkimItem + ')'"
              ref="DKIM-modal"
            >
              <b-row class="my-4">
                <b-col sm="2">
                  <label class="mb-0">
                    {{ $t("DOMAINS.ENABLED") }}
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-select
                    v-model="dkimform.enabled.selected"
                    value-field="value"
                    text-field="name"
                    :options="dkimEnabled"
                    @change="changeDkim()"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-4" v-show="dkimform.enabled.selected">
                <b-col sm="2">
                  <label class="mb-0">
                    {{ $t("DOMAINS.HOST") }}
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="dkimform.host" disabled></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-4" v-show="dkimform.enabled.selected">
                <b-col sm="2">
                  <label class="mb-0">
                    {{ $t("DOMAINS.KEY") }}
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-textarea
                    v-model="dkimform.key"
                    disabled
                    rows="8"
                  ></b-form-textarea>
                </b-col>
              </b-row>
              <template v-slot:modal-footer>
                <b-button
                  variant="danger"
                  v-on:click="confirmModalClose('DKIM-modal')"
                >
                  {{ $t("COMMON.OK") }}
                </b-button>
              </template>
            </b-modal>
            <!-- Verifying Ownership modal -->
            <b-modal
              :title="$t('DOMAINS.VERIFYING') + '(' + verificationItem + ')'"
              ref="VERIFYING-modal"
            >             
              <b-row class="my-4" v-if="verificationMessage">
                <b-col sm="12">
                    <b-alert show variant="danger">{{ verificationMessage }}</b-alert>
                    <br><br>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col sm="12">
                  <label class="mb-0">
                    <strong>{{ $t("DOMAINS.PLEASE_VERIFY") }}</strong>
		    <br><br>
                  </label>
                </b-col>
              </b-row>
              <b-row class="my-4">
		<b-col sm="4">
                  <label class="mb-0">
                    <strong>{{ $t("DOMAINS.HOSTNAME") }}</strong> 
                  </label>
                </b-col>
                <b-col sm="8">
			mx-verification
                </b-col>
              </b-row>
	      <b-row class="my-4">
                <b-col sm="4">
                  <label class="mb-0">
                    <strong>{{ $t("COMMON.TYPE") }}</strong>
                  </label>
                </b-col>
                <b-col sm="8">
                       	TXT 
                </b-col>
              </b-row>
	      <b-row class="my-4" justify="center"> 
                <b-col sm="4">
                  <label class="mb-0">
		    <strong>{{ $t("COMMON.VALUE") }}</strong>
                  </label>
                </b-col>
                <b-col sm="8">
                  <b-form-input v-model="verificationform.text" disabled></b-form-input>
                </b-col>
              </b-row>              
              <template v-slot:modal-footer>
                <b-button
                  variant="danger"
                  v-on:click="confirmModalClose('VERIFYING-modal')"
                >
                  {{ $t("COMMON.OK") }}
                </b-button>
              </template>
            </b-modal>
            <!-- Edit footer modal -->
            <b-modal
              :title="$t('DOMAINS.EDIT_FOOTER') + updateItem"
              ref="editFooter-modal"
            >
              <h6>
                <b-alert show variant="secondary">
                  {{ $t("DOMAINS.FOOTER_DESC") }}
                </b-alert>
              </h6>
              <vue-editor v-model="footerform.editorData"></vue-editor>
              <template v-slot:modal-footer>
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button
                  variant="outline-secondary"
                  v-on:click="confirmModalClose('editFooter-modal')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="danger" @click="updateFooterInfor()">
                  {{ $t("COMMON.UPDATE") }}
                </b-button>
              </template>
            </b-modal>
          </template>
        </KTPortlet>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import { postRequest } from "@/api/request.js";
import { required, minLength } from "vuelidate/lib/validators";
import { SETSTATUS } from "@/store/status.module";
import { VueEditor } from "vue2-editor";
// const mustBeDot = value =>
//   value.lastIndexOf(".") > 0 && value.length - value.lastIndexOf(".") != 1;
/**
 * Sample widgets data source
 */

export default {
  mixins: [validationMixin],
  name: "domain",
  components: {
    KTPortlet,
    VueEditor,
  },
  created() {
    this.getAllDomains();
    postRequest({
      action: "getTimezones",
      token: localStorage.id_token,
    }).then((res) => {
      if (res) {
        this.updateform.timeZone.data = res.returndata;
        this.updateform.timeZone.selected = res.returndata[0].timezone;
      }
    });

    postRequest({
      action: "getCountries",
      token: localStorage.id_token,
    }).then((res) => {
      if (res) {
        if (!res.returncode) {
          res.returndata = [{ text: res.returndata }];
        } else {
          for (var key in res.returndata) {
            this.updateform.homeCountry.data.push({
              value: key,
              text: res.returndata[key],
            });
          }
        }
      }
    });

    if (window.innerWidth < 600) this.isMobile = true;
    window.addEventListener("resize", this.resizeWin);

    // for (let i = 1; i < 61; i++) {
    //   this.updateform.expiryPolicy.data.push({ value: i, name: i });
    // }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWin);
  },

  data: () => ({
    // AI Settings State
    aiItem: "",
    aiLoading: false,
    aiStatusError: "",
    aiDefaultProvider: null,
    aiDeleteProvider: null, // Added this back to match the delete modal usage
    
    // Configuration map
    aiConfiguredProviders: {
      openai: { present: false, model: null },
      anthropic: { present: false, model: null },
      gemini: { present: false, model: null }
    },
    
    // Wizard State
    aiWizardMode: false,
    aiEditMode: false,
    aiWizard: {
      provider: null,
      apiKey: "",
      testing: false,
      modelsLoaded: false,
      modelOptions: [],
      selectedModel: null,
      saving: false
    },
    search: "",
    singleSelect: false,
    selected: [],
    form: {
      newDomain: null,
    },
    updateform: {
      timeZone: {
        selected: "",
        data: [],
      },
      homeCountry: {
        selected: "",
        data: [],
      },
      catmail: {
        selected: "bounce-no-mailbox",
      },
      active: {
        selected: 1,
      },
      localDelivery: {
        selected: 1,
      },
      audit: {
        selected: 0,
      },
    },
    dkimform: {
      enabled: {
        selected: 0,
      },
      host: "",
      key: "",
    },
    verificationform: {
      text: "",
      message: "",
    },
    footerform: {
      editorData: "",
    },
    allDomains: [],
    showItem: "",
    delItem: "",
    updateItem: "",
    dkimItem: "",
    verificationItem: "",
    verificationMessage: "",
    isMobile: false,
    domainType: 1
  }),
  validations: {
    form: {
      newDomain: {
        required,
        minLength: minLength(3),
        // mustBeDot
      },
    },
  },
  computed: {
    activeProvidersList() {
      const list = [];
      ['openai', 'anthropic', 'gemini'].forEach(key => {
        if (this.aiConfiguredProviders[key].present) {
          list.push({
            key: key,
            label: this.aiProviderLabel(key),
            model: this.aiConfiguredProviders[key].model
          });
        }
      });
      return list;
    },
    availableProvidersToAdd() {
      const opts = [{ value: null, text: this.$t("COMMON.SELECT") }];
      if (!this.aiConfiguredProviders.openai.present) opts.push({ value: 'openai', text: 'OpenAI' });
      if (!this.aiConfiguredProviders.gemini.present) opts.push({ value: 'gemini', text: 'Gemini' });
      if (!this.aiConfiguredProviders.anthropic.present) opts.push({ value: 'anthropic', text: 'Anthropic' });
      return opts;
    },
    aiCanVerify() {
      if (!this.aiWizard.provider) return false;
      // If editing and field is empty (keep existing), we can verify using stored key
      if (this.aiEditMode && !this.aiWizard.apiKey) return true; 
      // Otherwise need a key
      return this.aiWizard.apiKey && this.aiWizard.apiKey.length > 5;
    },

    headers: function () {
      return [
        { text: this.$t("COMMON.DOMAIN"), value: "domain" },
        { text: this.$t("DOMAINS.HEALTH"), value: "health" },
        { text: this.$t("COMMON.ACTION"), value: "action", sortable: false },
      ];
    },
    catmailData: function () {
      return [
        { value: "bounce-no-mailbox", name: this.$t("DOMAINS.NO_CATCHALL") },
        { value: "delete", name: this.$t("DOMAINS.ACCEPT_DELETE") },
      ];
    },
    activeData: function () {
      return [
        { value: 1, name: this.$t("COMMON.YES") },
        { value: 0, name: this.$t("COMMON.NO") },
      ];
    },
    localDeliveryData: function () {
      return [
        { value: 1, name: this.$t("COMMON.YES") },
        { value: 0, name: this.$t("COMMON.NO") },
      ];
    },
    auditData: function () {
      return [
        { value: 1, name: this.$t("COMMON.YES") },
        { value: 0, name: this.$t("COMMON.NO") },
      ];
    },
    dkimEnabled: function () {
      return [
        { value: 1, name: this.$t("COMMON.YES") },
        { value: 0, name: this.$t("COMMON.NO") },
      ];
    },
    domainTypesOptions: function () {
      return [
        { value: 1, name: this.$t("COMMON.REGULAR") },
        { value: 0, name: this.$t("DOMAINS.OEX") },
      ];
    },
    canAdd: function () {
      return this.hasPermission("domains", 5);
    },
    canRemove: function () {
      return this.hasPermission("domains", 7);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("MENU.DOMAINS") }]);
    this.$store.dispatch(SETSTATUS, {
      action: "getAdminStats",
      token: localStorage.id_token,
    });
  },
  methods: {
    /* -----validation---- */
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    /*  -----modal close------- */
    modalClose() {
      this.form.newDomain = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.$refs["addDomain"].hide();
    },
    confirmModalClose(modalItem) {
      this.$refs[modalItem].hide();
    },
    //  resize windows for mobile responsive
    resizeWin() {
      if (window.innerWidth < 600) this.isMobile = true;
      else this.isMobile = false;
    },

    /* ----------get all domain----- */
    getAllDomains() {
      this.allDomains = [];
      this.selected = [];
      postRequest({
        action: "getAllDomains",
        token: localStorage.id_token,
      }).then((res) => {
        if (res) {
          if (!res.returncode) {
            res.returndata = [{ domain: res.returndata }];
          } else {
            let i;
            for (i in res.returndata) {
              if (res.returndata[i].isauditdomain != 1) {
                let obj = res.returndata[i];
                obj.health = this.getDomainHealthScore(obj);
                obj.healthStatus = obj.health < 3 ? this.$t("DOMAINS.FAIL") : obj.health < 5 ? this.$t("COMMON.WARNING"):this.$t("DOMAINS.OK");
                this.allDomains.push(obj);
              }
            }
          }
        }
      });
    },

getDomainHealthScore(domain){
  if (domain.verification == 1)
    return 0; // red
  if (domain.active != 1)
    return 1; // red
  if (domain.mx_health != 1)
    return 2; // red

  // non-critical (yellow)
  if (domain.caa_block == 1)
    return 3; // yellow

  if (
    domain.webmail_health != 1 || domain.webmail_ssl != 1 ||
    domain.autodiscover_health != 1 || domain.autodiscover_ssl != 1 ||
    domain.spf_health != 1 || domain.dkim_health != 1
  ) {
    return 4; // yellow
  }

  return 5; // green
},

    /* ------create item---- */
    createItem() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let action = "addDomain";

      if (this.domainType == 0) {
        action = "addOEXDomain";
      }

      postRequest({
        action: action,
        token: localStorage.id_token,
        newdomain: this.form.newDomain,
      }).then((res) => {
        this.modalClose();
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
          this.getAllDomains();
          this.$store.dispatch(SETSTATUS, {
            action: "getAdminStats",
            token: localStorage.id_token,
          });
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    /* -------delete item----- */
    saveDeltem(item) {
      this.delItem = item;
    },
    deleteOneItem() {
      const item = this.delItem;
      postRequest({
        action: "removeDomain",
        token: localStorage.id_token,
        domain: item.domain,
      }).then((res) => {
        this.confirmModalClose("delConfirm-modal");
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
        this.$store.dispatch(SETSTATUS, {
          action: "getAdminStats",
          token: localStorage.id_token,
        });
        this.getAllDomains();
      });
    },
    deleteItems() {
      if (this.selected.length > 0) {
        this.selected.forEach((el) => {
          postRequest({
            action: "removeDomain",
            token: localStorage.id_token,
            domain: el.domain,
          }).then((res) => {
            this.confirmModalClose("delConfirm-modal");
            if (res.returncode) {
              this.makeToastVariant("success", res.returndata);
            } else {
              this.makeToastVariant("danger", res.returndata);
            }
            this.$store.dispatch(SETSTATUS, {
              action: "getAdminStats",
              token: localStorage.id_token,
            });
            for (let i = 0; i < this.allDomains.length; i++) {
              if (this.allDomains[i].id == el.id) {
                this.allDomains.splice(i, 1);
              }
            }
          });
        });
      }
    },

    /* -------domain health------ */
    showDomainHealth(item) {
      this.showItem = item;
      this.getDomainHealth();
      this.$refs["modal-health"].show();
    },
getDomainHealth() {
  const showItem = this.showItem;
  postRequest({
    action: "getDomainHealth",
    token: localStorage.id_token,
    domain: this.showItem.domain,
  }).then((res) => {
    if (res.returncode) {
      showItem.mx_health = res.returndata.mx_health;
      showItem.check_next = res.returndata.check_next;
      showItem.caa_block = res.returndata.caa_block;
      showItem.webmail_health = res.returndata.webmail_health;
      showItem.webmail_ssl = res.returndata.webmail_ssl;
      showItem.autodiscover_health = res.returndata.autodiscover_health;
      showItem.autodiscover_ssl = res.returndata.autodiscover_ssl;
      showItem.spf_health = res.returndata.spf_health;

      // NEW:
      showItem.autoconfig_health = res.returndata.autoconfig_health;
      showItem.autoconfig_ssl   = res.returndata.autoconfig_ssl;
      showItem.dkim_health      = res.returndata.dkim_health;

      showItem.health = this.getDomainHealthScore(showItem);
      showItem.healthStatus =
        showItem.health < 3
          ? this.$t("DOMAINS.FAIL")
          : showItem.health < 5
            ? this.$t("COMMON.WARNING")
            : this.$t("DOMAINS.OK");

      if (this.showItem.domain == showItem.domain)
        this.showItem = showItem;
    }
  });
},
    checkDomainHealthNext() {
      if (this.showItem.check_next == 0) {
        postRequest({
          action: "dnsCheckNext",
          token: localStorage.id_token,
          domain: this.showItem.domain,
        }).then((res) => {
          this.confirmModalClose("modal-health");
          if (res.returncode) {
            this.makeToastVariant("success", res.returndata);
            this.makeToastVariant("success", this.$t("DOMAINS.CHECK_HEALTH_INFO"));
          } else {
            this.makeToastVariant("danger", res.returndata);
          }
        });
      } else {
        this.makeToastVariant("success", this.$t("DOMAINS.CHECK_HEALTH_INFO"));
        this.confirmModalClose("modal-health");
      }
    },

    /* ------edit item----- */
    async showItemInfor(item) {
      await postRequest({
        action: "getDomainInfo",
        token: localStorage.id_token,
        domain: item.domain,
      }).then((res) => {
        this.updateItem = item.domain;
        this.updateform.timeZone.selected = res.returndata.dtzone;
        this.updateform.homeCountry.selected = res.returndata.homecountry;
        this.updateform.catmail.selected = res.returndata.catchall;
        this.updateform.active.selected = res.returndata.active;
        this.updateform.localDelivery.selected = res.returndata.localdelivery;
        this.updateform.audit.selected = res.returndata.audit_enabled;
      });
      this.catmailData.splice(2);
      await postRequest({
        action: "getAllUsersDomain",
        token: localStorage.id_token,
        domain: item.domain,
        offset: 0,
        limit: 0,
        sorting: 0,
        slicing: 0,
        getOTPAndToken: 0,
        showQuota: 0,
      }).then((res) => {
        if (res.returncode) {
          res.returndata.forEach((el) => {
            this.catmailData.push({
              value: el.username,
              name: el.username,
            });
          });
        }
      });
      this.$refs["editDomain-modal"].show();
    },

    updateItemInfor() {
      const updateItem = this.updateItem;
      const acitveState = this.updateform.active.selected;
      postRequest({
        action: "updateDomain",
        domain: this.updateItem,
        token: localStorage.id_token,
        editdtzone: this.updateform.timeZone.selected,
        homecountry: this.updateform.homeCountry.selected,
        editcatchall: this.updateform.catmail.selected,
        editdomainactive: this.updateform.active.selected,
        editlocaldelivery: this.updateform.localDelivery.selected,
        editauditenabled: this.updateform.audit.selected,
      }).then((res) => {
        this.allDomains.forEach((el) => {
          if (el.domain == updateItem) {
            el.active = acitveState;
          }
        });
        this.confirmModalClose("editDomain-modal");
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    /* -------edit footer------ */
    showItemFooter(item) {
      postRequest({
        action: "getFooterDomain",
        token: localStorage.id_token,
        domain: item.domain,
      }).then((res) => {
        this.$refs["editFooter-modal"].show();
        this.updateItem = item.domain;
        this.footerform.editorData = res.returndata;
      });
    },

    updateFooterInfor() {
      postRequest({
        action: "setFooterDomain",
        footertxt: this.footerform.editorData,
        token: localStorage.id_token,
        domain: this.updateItem,
      }).then((res) => {
        this.confirmModalClose("editFooter-modal");
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    /* -------Domain Verification */
    showDomainVerification(item) {
      this.verificationItem = item.domain;
      postRequest({
        action: "getDomainVerification",
        token: localStorage.id_token,
        domain: item.domain,
      }).then((res) => {
        if (res.returncode) {
	        this.verificationMessage=res.message;
          this.verificationform.text = res.returndata;
          this.$refs["VERIFYING-modal"].show();
        }
      });
    },

    /* -------DKIM Settings------ */
    showDkimSetting(item) {
      this.dkimItem = item.domain;
      postRequest({
        action: "getDKIM",
        token: localStorage.id_token,
        domain: item.domain,
      }).then((res) => {
        if (res.returncode) {
          this.dkimform.enabled.selected = res.returndata.dkim_enabled * 1;
          this.dkimform.host = res.returndata.dkim_host;
          this.dkimform.key = res.returndata.dkim_key;
          this.$refs["DKIM-modal"].show();
        }
      });
    },

    changeDkim() {
      if (this.dkimform.enabled.selected) {
        postRequest({
          action: "enableDKIM",
          token: localStorage.id_token,
          domain: this.dkimItem,
        }).then((res) => {
          if (res.returncode) {
            this.makeToastVariant("success", res.returndata);
            this.dkimform.host = res.dkimhost;
            this.dkimform.key = res.dkimkey;
          } else {
            this.makeToastVariant("danger", res.returndata);
          }
        });
      } else {
        postRequest({
          action: "disableDKIM",
          token: localStorage.id_token,
          domain: this.dkimItem,
        }).then((res) => {
          if (res.returncode) {
            this.makeToastVariant("success", res.returndata);
            this.dkimform.host = "";
            this.dkimform.key = "";
          } else {
            this.makeToastVariant("danger", res.returndata);
          }
        });
      }
    },

/* ===== AI Settings Implementation ===== */
    
    aiProviderLabel(key) {
      const map = { openai: 'OpenAI', anthropic: 'Anthropic', gemini: 'Gemini' };
      return map[key] || key;
    },

    showAiSettings(item) {
      this.aiItem = item.domain;
      this.aiWizardMode = false;
      this.aiLoading = true;
      this.aiStatusError = "";
      
      postRequest({
        action: "getDomainLlmStatus", // Ensure this matches your PHP method name
        token: localStorage.id_token,
        domain: item.domain
      }).then(res => {
        this.aiLoading = false;
        if (!res || !res.returncode) {
          this.aiStatusError = (res && res.returndata) || "Failed to load AI settings";
          this.$refs["AI-modal"].show();
          return;
        }
        
        const status = res.returndata || {};
        
        // Populate configured providers list
        ['openai', 'anthropic', 'gemini'].forEach(k => {
          this.aiConfiguredProviders[k] = {
            present: !!(status[k] && status[k].present),
            model: (status[k] && status[k].model) ? status[k].model : null
          };
        });

        // Determine default
        let def = null;
        ['openai', 'anthropic', 'gemini'].forEach(k => {
          if (status[k] && status[k].default) def = k;
        });
        this.aiDefaultProvider = def;

        this.$refs["AI-modal"].show();
      });
    },

    aiStartWizard() {
      this.aiWizard = {
        provider: null,
        apiKey: "",
        testing: false,
        modelsLoaded: false,
        modelOptions: [],
        selectedModel: null,
        saving: false
      };
      this.aiEditMode = false;
      this.aiWizardMode = true;
    },

    aiEditProvider(provider) {
      this.aiWizard = {
        provider: provider,
        apiKey: "", // Blank means "keep existing"
        testing: false,
        modelsLoaded: false, // Force them to re-verify/fetch to change model
        modelOptions: [],
        selectedModel: this.aiConfiguredProviders[provider].model,
        saving: false
      };
      this.aiEditMode = true;
      this.aiWizardMode = true;
    },

    aiCancelWizard() {
      this.aiWizardMode = false;
      this.aiStatusError = "";
    },

aiVerifyAndFetchModels() {
      const wizardState = this.aiWizard;
      wizardState.testing = true;
      this.aiStatusError = "";

      postRequest({
        action: "ListProviderModels", 
        token: localStorage.id_token,
        domain: this.aiItem,
        provider: wizardState.provider,
        apiKey: wizardState.apiKey // Ensure this matches PHP $apiKey
      }).then(res => {
        wizardState.testing = false;
        if (res && res.returncode) {
           wizardState.modelOptions = res.returndata.models || [];
           wizardState.modelsLoaded = true;
           
           // If editing, ensure previously selected model is still valid/selected
           if (this.aiEditMode && !wizardState.selectedModel && res.returndata.selected) {
             wizardState.selectedModel = res.returndata.selected;
           }
           // If no selection yet, default to the first one
           if (!wizardState.selectedModel && wizardState.modelOptions.length > 0) {
             wizardState.selectedModel = wizardState.modelOptions[0].id;
           }
           
           this.makeToastVariant("success", this.$t("DOMAINS.AI_MODELS_FETCHED") || "Models fetched successfully");
        } else {
           this.aiStatusError = (res && res.returndata) || "Verification failed";
        }
      }).catch(() => {
         wizardState.testing = false;
         this.aiStatusError = "Network error during verification";
      });
    },

    aiSaveProvider() {
      const p = this.aiWizard;
      p.saving = true;

      // 1. Define the Promise to save the key (skip if empty/editing)
      const saveKeyPromise = () => {
        if (p.apiKey && p.apiKey.length > 0) {
          return postRequest({
            action: "setDomainLlmKey",
            token: localStorage.id_token,
            domain: this.aiItem,
            provider: p.provider,
            apikey: p.apiKey
          });
        }
        return Promise.resolve({ returncode: 1 }); 
      };

      saveKeyPromise().then(resKey => {
        if (!resKey.returncode) {
           throw new Error(resKey.returndata || "Failed to save API Key");
        }

        // 2. Save the Model preference
        // Ensure backend maps "setDomainLlmModel" to "llm_set_provider_model"
        return postRequest({
          action: "SetProviderModel",
          token: localStorage.id_token,
          domain: this.aiItem,
          provider: p.provider,
          model: p.selectedModel
        });
      }).then(resModel => {
        p.saving = false;
        if (resModel.returncode) {
          this.makeToastVariant("success", "Provider saved successfully");
          
          // Update local state instantly
          this.aiConfiguredProviders[p.provider].present = true;
          this.aiConfiguredProviders[p.provider].model = p.selectedModel;
          
          // If no default set, set this one automatically
          if (!this.aiDefaultProvider) {
            this.aiSetDefault(p.provider);
          }

          this.aiWizardMode = false;
        } else {
          throw new Error(resModel.returndata || "Failed to save model selection");
        }
      }).catch(err => {
        p.saving = false;
        this.makeToastVariant("danger", err.message);
      });
    },

    aiSetDefault(provider) {
      postRequest({
        action: "setDomainDefaultLlmProvider",
        token: localStorage.id_token,
        domain: this.aiItem,
        provider: provider
      }).then(res => {
        if (res.returncode) {
          this.aiDefaultProvider = provider;
          this.makeToastVariant("success", "Default provider updated");
        } else {
          this.makeToastVariant("danger", "Failed to set default");
        }
      });
    },

    aiConfirmDelete(provider) {
      // Assuming you use BootstrapVue msgBoxConfirm or standard confirm
      this.aiDeleteProvider = provider;
      this.$refs["AI-delete-modal"].show();
    },
    
    // Real delete action triggered from modal
    aiDeleteProviderKey() {
       const provider = this.aiDeleteProvider;
       postRequest({
         action: "deleteDomainLlmKey",
         token: localStorage.id_token,
         domain: this.aiItem,
         provider: provider
       }).then(res => {
         this.$refs["AI-delete-modal"].hide();
         if (res.returncode) {
           this.aiConfiguredProviders[provider].present = false;
           this.aiConfiguredProviders[provider].model = null;
           if (this.aiDefaultProvider === provider) {
		this.aiDefaultProvider = null;
	   }
           this.makeToastVariant("success", "Provider deleted");
         } else {
           this.makeToastVariant("danger", res.returndata);
         }
       });
    },

    /* ----notify---- */
    makeToastVariant(variant = null, msg) {
      let title = this.$t("COMMON.ERROR");
      if (variant == "success") {
        title = this.$t("COMMON.SUCCESS");
      }
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        // autoHideDelay: 5000,
        solid: true,
      });
    },
  },
};
</script>
<style>
:root {
  --ck-z-default: 100 !important;
  --ck-z-modal: calc(var(--ck-z-default) + 999) !important;
}
</style>
